import React from "react";
import styled from "styled-components";
import image1 from "../assets/Servicepages.png";
import gifImage from "../assets/gif-ourservices.gif";
import gifImg1 from "../assets/brainstorm-gif.gif";
import backgroundImg from "../assets/Bg_mobile.png";
import centerimage from "../assets/mobile apps (1).png";
import gifImg2 from "../assets/digital-art-gif.gif";
import gifImg3 from "../assets/programmer-gif.gif";
import gifImg4 from "../assets/quality-assurance-gif.gif";
import gifImg5 from "../assets/society-gif.gif";
import gifImg6 from "../assets/ui ux.gif";
import centerimage2 from "../assets/mobile games (1).png";
import gifImg7 from "../assets/brainstorming-gif.gif";
import gifImg8 from "../assets/checklist-unscreen.gif";
import gifImg9 from "../assets/coder-unscreen.gif";
import gifImg10 from "../assets/drawing-unscreen.gif";
import gifImg11 from "../assets/media-mix-unscreen.gif";
import gifImg12 from "../assets/supermarket-unscreen.gif";
import centerimge3 from "../assets/Everything website.png";
import gifImg13 from "../assets/landingpage-gif.gif";
import gifImg14 from "../assets/qa-gif.gif";
import gifImg15 from "../assets/ui_ux-gif.gif";
import gifImg16 from "../assets/web content-gif.gif";
import gifImg17 from "../assets/webdesign-gif.gif";
import gifImg18 from "../assets/webdeveloper-gif.gif";
import gifbackgroundiamge from "../assets/blue circle-2.png";
import gifbackgroundiamge1 from "../assets/green circle-2.png";
import gifbackgroundiamge2 from "../assets/yellow circle-2.png";

// Styled Components
const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0;
  padding: 0;
  overflow-x: hidden;
`;

const ServiceHeader = styled.h1`
  margin-bottom: 20px;
  font-size: 28px;
  font-weight: bold;
  color: #333;
`;

const BackgroundImage = styled.div`
  width: 100%;
  height: auto;
  background: url(${backgroundImg}) center/cover no-repeat;
  padding: 80px 0;
  display: flex;
  flex-direction: column;
  align-items: center;

  @media (max-width: 1024px) {
    padding: 60px 0; /* Thoda padding kam */
  }

  @media (max-width: 768px) {
    padding: 50px 0; /* Mobile devices pe aur kam */
    background-size: contain; /* Background image adjust */
  }

  @media (max-width: 480px) {
    padding: 0px 0;
    background-position: top; /* Mobile pe image better dikhe */
  }
`;

const ServiceGif = styled.img`
  width: 477px;
  height: 595px;
  position: absolute;
  top: 130px;
  right: 50px;
  z-index: 1;

  @media (max-width: 1024px) {
    width: 350px;
    height: 450px;
    top: 100px;
    right: 30px;
  }

  @media (max-width: 768px) {
    width: 180px;
    height: 260px;
    top: 80px;
    right: 20px;
  }

  @media (max-width: 480px) {
    width: 100px;
    height: 150px;
    top: 100px;
    right: 10px;
  }
`;

const ServiceImage = styled.img`
  width: 100%;
  height: auto;
  position: relative;
`;

const ContentContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 20px;
  /* background-color: red; */
  width: 80%;

  @media (max-width: 1024px) {
    width: 90%;
  }

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: center;
    width: 100%;
  }
`;
const ContentContainer1 = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 20px;
  /* background-color: #0011ff; */
  width: 80%;

  @media (max-width: 1024px) {
    width: 90%;
  }

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: center;
    width: 100%;
  }
`;

const Card = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  /* background-color: yellow; */
  border-radius: 10px;
  width: 32%;
  gap: 20px;
  @media (max-width: 1300px) {
    width: 31%;
  }
  @media (max-width: 1024px) {
    width: 92%;
  }
`;
const Card1 = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  background-color: pink;
  border-radius: 10px;
  width: 32%;
  gap: 20px;
`;

const CardContent = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 10px;

  @media (max-width: 1024px) {
    padding: 8px;
  }

  @media (max-width: 768px) {
    padding: 6px;
    text-align: left;
    justify-content: left;
    align-items: flex-start;
  }

  @media (max-width: 480px) {
    padding: 5px;
    text-align: left;
    justify-content: left;
    align-items: flex-start;
  }
`;

const CardContent11 = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 10px;

  @media (max-width: 1024px) {
    padding: 8px;
  }

  @media (max-width: 768px) {
    padding: 6px;
   text-align: right;
    justify-content: right;
    align-items: flex-end;
  }

  @media (max-width: 480px) {
    padding: 5px;
    text-align: right;
    justify-content: right;
    align-items: flex-end;
  }
`;

const CardTitle = styled.h3`
  font-size: 20px;
  margin-bottom: 10px;
  color: #000000;

  @media (max-width: 1024px) {
    font-size: 18px;
  }

  @media (max-width: 768px) {
    font-size: 16px;
    text-align: center;
  }

  @media (max-width: 480px) {
    font-size: 15px;
    text-align: center;
    margin-bottom: 8px;
  }
`;

const CardDescription = styled.p`
  font-size: 16px;
  color: #000000;

  @media (max-width: 1300px) {
    font-size: 14px;
  }

  @media (max-width: 1024px) {
    font-size: 15px;
  }

  @media (max-width: 768px) {
    font-size: 14px;
  }

  @media (max-width: 480px) {
    font-size: 13px;
    /* text-align: center; */
  }
`;

const CardImage = styled.img`
  width: 100px;
  height: 100px;
  border-radius: 10px;
  /* background-color: yellow; */
  z-index: 1;
`;
const CardImage1 = styled.img`
  width: 110px;
  height: auto;
  /* border-radius: 10px; */
  position: absolute;
  /* background-color: yellow; */
`;

const Centrimage1 = styled.img`
  width: 100%;
  height: auto;
  position: relative;
`;

const HireDeveloper = () => {
  return (
    <Wrapper>
      <ServiceGif src={gifImage} alt="Animated Service Gif" />
      <ServiceImage src={image1} alt="Service Image" />
      <BackgroundImage>
        <ContentContainer1>
          <Card>
            {/* <CardImage1 src={gifbackgroundiamge} alt="Animated Graphic" /> */}
            <CardContent data-aos="zoom-in-right">
              <CardTitle>01 Brainstorming </CardTitle>
              <CardDescription>
                Greate apps start with a great ideas! We dive deep, exploring
                possibilities, trends, and user needs to shape concepts that
                truly stand out.
              </CardDescription>
            </CardContent>
            <CardImage data-aos="zoom-in-left" src={gifImg1} alt="Animated Graphic" />
          </Card>
          <Card>
            <CardImage data-aos="zoom-in-right" src={gifImg2} alt="Animated Graphic" />
            {/* <CardImage1 src={gifbackgroundiamge1} alt="Animated Graphic" /> */}
            <CardContent11 data-aos="zoom-in-left">
              <CardTitle>App Design 02</CardTitle>
              <CardDescription>
                Sleek, smart, and stunning-our designs blend easthetics with
                usability, ensuring your app looks incredible while being
                effortless to navigate.
              </CardDescription>
            </CardContent11>
          </Card>
        </ContentContainer1>

        <ContentContainer>
          <Card>
            {/* <CardImage1 src={gifbackgroundiamge2} alt="Animated Graphic" /> */}
            <CardContent data-aos="zoom-in-right">
              <CardTitle>03 UI/UX and mockups </CardTitle>
              <CardDescription>
                First impressions matter! We craft intuitive interfaces and
                interactive prototypes, giving, you a sneak peek at your app's
                user experience before development.{" "}
              </CardDescription>
            </CardContent>
            <CardImage data-aos="zoom-in-left" src={gifImg3} alt="Animated Graphic" />
          </Card>
          <Card>
            <Centrimage1 data-aos="flip-left" src={centerimage} alt="Animated Graphic" />
          </Card>
          <Card>
            <CardImage data-aos="zoom-in-right" src={gifImg4} alt="Animated Graphic" />
            <CardContent11 data-aos="zoom-in-left">
              <CardTitle>App Development 04</CardTitle>
              <CardDescription>
                Code with character! Our developers bring your app to life with
                performance- driven, scaleble, and secure solutions built to
                thrive.
              </CardDescription>
            </CardContent11>
          </Card>
        </ContentContainer>

        <ContentContainer>
          <Card>
            <CardContent data-aos="zoom-in-right">
              <CardTitle>05 Quality Assurance </CardTitle>
              <CardDescription>
                No bugs allowed! We text, tweak, and fine=tune every aspect of
                your app to ensure it runs flawlessly across all devices and
                platforms.
              </CardDescription>
            </CardContent>
            <CardImage data-aos="zoom-in-left" src={gifImg5} alt="Animated Graphic" />
          </Card>
          <Card>
            <CardImage data-aos="zoom-in-right" src={gifImg6} alt="Animated Graphic" />
            {/* <CardImage1 src={gifbackgroundiamge} alt="Animated Graphic" /> */}
            <CardContent11 data-aos="zoom-in-left">
              <CardTitle>Team of Exports 06</CardTitle>
              <CardDescription>
                From visionary designers to coding wizards, our diverse team
                brings expertise, passion, and createvity to every project. Your
                app is in the best hands!
              </CardDescription>
            </CardContent11>
          </Card>
        </ContentContainer>
      </BackgroundImage>

      <BackgroundImage>
        <ContentContainer>
          <Card>
            <CardContent data-aos="zoom-in-right">
              <CardTitle>01 Brainstorming </CardTitle>
              <CardDescription>
                We dream big! Our team transfroms wild ideas into structured,
                engaging game concepts that captivate players and keep them
                coming back.
              </CardDescription>
            </CardContent>
            <CardImage data-aos="zoom-in-left" src={gifImg7} alt="Animated Graphic" />
          </Card>
          <Card>
            <CardImage data-aos="zoom-in-right" src={gifImg8} alt="Animated Graphic" />
            <CardContent11 data-aos="zoom-in-left">
              <CardTitle>Game Design 02</CardTitle>
              <CardDescription>
                Strategy, mechanics, and fun-our game designers crafts
                experiences that challenge, entertain, and create unforgettable
                adventures for players worldwide.
              </CardDescription>
            </CardContent11>
          </Card>
        </ContentContainer>

        <ContentContainer>
          <Card>
            <CardContent data-aos="zoom-in-right">
              <CardTitle>03 Game Art </CardTitle>
              <CardDescription>
                From pixel-perfect characters to breathtaking landscapes, we
                bring worlds to life with stunning visuals and immersive designs
                that spark imagination.
              </CardDescription>
            </CardContent>
            <CardImage data-aos="zoom-in-left" src={gifImg9} alt="Animated Graphic" />
          </Card>
          <Card>
            <Centrimage1 data-aos="flip-right" src={centerimage2} alt="Animated Graphic" />
          </Card>
          <Card>
            <CardImage data-aos="zoom-in-right" src={gifImg10} alt="Animated Graphic" />
            <CardContent11 data-aos="zoom-in-left">
              <CardTitle>Game Development 04</CardTitle>
              <CardDescription>
                We code magic into every frame! Smooth gameplay, innovative
                mechanics, and seamless performance ensure an engaging
                experience across all devices.
              </CardDescription>
            </CardContent11>
          </Card>
        </ContentContainer>

        <ContentContainer>
          <Card>
            <CardContent data-aos="zoom-in-right">
              <CardTitle>05 Quality Assurance </CardTitle>
              <CardDescription>
                No glitches, just greatness! We rigorously test and fine-tune
                every element to guarantee smooth gameplay and an unforgettable
                player experience.
              </CardDescription>
            </CardContent>
            <CardImage data-aos="zoom-in-left" src={gifImg11} alt="Animated Graphic" />
          </Card>
          <Card>
            <CardImage data-aos="zoom-in-right" src={gifImg12} alt="Animated Graphic" />
            <CardContent11 data-aos="zoom-in-left">
              <CardTitle>LiveOps & Store 06</CardTitle>
              <CardDescription>
                The game doesn't end at launch! We handle updates, events, and
                monetization strategies to keep players engaged and revenue
                growing.
              </CardDescription>
            </CardContent11>
          </Card>
        </ContentContainer>
      </BackgroundImage>

      <BackgroundImage>
        <ContentContainer>
          <Card>
            <CardContent data-aos="zoom-in-right">
              <CardTitle>01 Web Design </CardTitle>
              <CardDescription>
                We craft sleek, visually stunning websites that blend creativity
                with usability, ensuring a seamless, engaging experience for
                visitors on any device.
              </CardDescription>
            </CardContent>
            <CardImage data-aos="zoom-in-left" src={gifImg13} alt="Animated Graphic" />
          </Card>
          <Card>
            <CardImage data-aos="zoom-in-right" src={gifImg14} alt="Animated Graphic" />
            <CardContent11 data-aos="zoom-in-left">
              <CardTitle>UI/UX 02</CardTitle>
              <CardDescription>
                User experience matters! We design intuitive, interactive, and
                visually compelling interfaces that make navigation effortless
                and experience unforgettable.
              </CardDescription>
            </CardContent11>
          </Card>
        </ContentContainer>

        <ContentContainer>
          <Card>
            <CardContent data-aos="zoom-in-right">
              <CardTitle>03 Web Development </CardTitle>
              <CardDescription>
                From front-end magic to back-end wizardry, we build high-
                performance, secure, end scalable websites that work flawlessly
                across all platforms.
              </CardDescription>
            </CardContent>
            <CardImage data-aos="zoom-in-left" src={gifImg15} alt="Animated Graphic" />
          </Card>
          <Card>
            <Centrimage1 data-aos="flip-right" src={centerimge3} alt="Animated Graphic" />
          </Card>
          <Card>
            <CardImage data-aos="zoom-in-right" src={gifImg16} alt="Animated Graphic" />
            <CardContent11 data-aos="zoom-in-left">
              <CardTitle>Web Content 04</CardTitle>
              <CardDescription>
                Compelling words, striking visuals, and engaging layouts-our
                conent strategy ensures your websites speaks to and captivates
                your audience instantly.
              </CardDescription>
            </CardContent11>
          </Card>
        </ContentContainer>

        <ContentContainer>
          <Card>
            <CardContent data-aos="zoom-in-right"> 
              <CardTitle>05 Quality Assurance </CardTitle>
              <CardDescription>
                We fine-tune every pixel and line of code, testing rigorously to
                ensure your website delivers a flawless, bug-free experience.
              </CardDescription>
            </CardContent>
            <CardImage data-aos="zoom-in-left" src={gifImg17} alt="Animated Graphic" />
          </Card>
          <Card>
            <CardImage data-aos="zoom-in-right" src={gifImg18} alt="Animated Graphic" />
            <CardContent11 data-aos="zoom-in-left">
              <CardTitle>Landing Page 06</CardTitle>
              <CardDescription>
                Your first impression counts! We design high-converting landing
                pages that capture attention, drive action, and trun visitors
                into customers,
              </CardDescription>
            </CardContent11>
          </Card>
        </ContentContainer>
      </BackgroundImage>
    </Wrapper>
  );
};

export default HireDeveloper;
